<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-05-07 16:33:22
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Announcement\viewAnnouncement.vue
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 11:24:41
-->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="$t('label_essweb_Announcement_form_viewTitle')"
    backgroundClass="white"
  >
    <template v-slot:appendTitle>
      <StatusChip
        content-class="mx-2"
        icon
        :slideColor="
          Number(announcementData.send_status) == 0
            ? 'green'
            : Number(announcementData.send_status) == 1
            ? 'orange'
            : Number(announcementData.send_status) == 2
            ? 'grey'
            : 'grey'
        "
      >
        <template v-slot:status>
          {{ $getCommonLangValue(announcementData.send_status_detail) }}
        </template>
      </StatusChip>
    </template>
    <template v-slot:nav-actions>
      <v-btn
        v-if="
          Number(announcementData.send_status) === 1 &&
          hasBtn('end-company-announcement')
        "
        class="mr-2 text-capitalize white--text"
        color="red"
        :ripple="false"
        @click="
          $confirmDo(
            $t('label_essweb_admin_Announcement_list_title'),
            $t('message_essweb_Announcement_form_revocationTitle'),
            $t('message_essweb_Announcement_form_isRevocationLabel'),
            null,
            $t('message_essweb_Announcement_form_revocationBtnLabel')
          ).then((res) => {
            res ? toRefuse() : null;
          })
        "
        >{{ $t("label_essweb_Announcement_form_toEndBtnLabel") }}</v-btn
      >
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              readonly
              :filled="false"
              v-model="announcementData.message_title"
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="200"
              :label="
                $t('label_essweb_Announcement_form_announcementTitleLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              readonly
              :filled="false"
              :value="
                $getDateTime(
                  announcementData.send_start_utc_datetime,
                  'YYYY/MM/DD HH:mm'
                ) +
                ' - ' +
                $getDateTime(
                  announcementData.send_end_utc_datetime,
                  'YYYY/MM/DD HH:mm'
                )
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_Announcement_form_publicTimeLabel')"
            />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_Announcement_form_orgLeaveLabel")
            }}</v-sheet>
            <v-combobox
              v-model="curSend"
              :items="[]"
              multiple
              readonly
              :filled="false"
              append-icon=""
              item-color="transparent"
              small-chips
              :rules="$GetRules(['_Require_ArrRules'], [null])"
              dense
              single-line
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  class="mx-1 my-1"
                  :input-value="data.selected"
                  v-if="data.index < $selectSetting.maxChips"
                  @click="data.select"
                >
                  {{ $getCommonLangValue(data.item.org_level_name) }}
                </v-chip>
                <span
                  v-if="data.index === $selectSetting.maxChips"
                  class="text--primary py-2"
                >
                  ...{{
                    announcementData.send_org_level_uuid.length -
                    $selectSetting.maxChips
                  }}{{ $t("label_essweb_selection_moreItemLabel") }}
                </span>
              </template>
              <template v-slot:no-data>
                <noContent v-if="orgData.length == 0" />
                <v-treeview
                  selectable
                  v-else
                  open-all
                  open-on-click
                  selected-color="primary"
                  :items="orgData"
                  item-key="uuid"
                  :search="search"
                  :filter="filter"
                  v-model="announcementData.send_org_level_uuid"
                  return-object
                  item-text="org_level_shortcode"
                  item-children="son_org"
                >
                  <template v-slot:label="{ item }">
                    <span
                      class="text--secondary"
                      v-html="hightLightKeyword(item.org_level_name, search)"
                    ></span>
                  </template>
                </v-treeview>
              </template>
            </v-combobox>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              readonly
              :filled="false"
              v-model="announcementData.message_content"
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="200"
              :label="$t('label_essweb_Announcement_form_contentLabel')"
            />
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            v-if="Number(announcementData.send_status) === 1"
          >
            <v-sheet class="mrc_text_require text--secondary">
              {{ $t("label_essweb_Announcement_form_hasBeenReadLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              single-line
              height="42"
              :value="
                (announcementData.read_num || 0) +
                '/' +
                (announcementData.total || 0)
              "
              dense
            >
              <template v-slot:append-outer>
                <v-btn
                  outlined
                  color="primary"
                  class="text-capitalize"
                  @click="showDetail"
                  >{{
                    $t(
                      "label_essweb_Announcement_form_hasBeenReadDetailBtnLabel"
                    )
                  }}</v-btn
                >
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions> </template>
    <!-- actions -->
    <template v-slot:tools-main>
      <showDetailReaded
        :show="showDetailReadedDialog"
        :curUuid="$route.params.id"
        @close="showDetailReadedDialog = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import showDetailReaded from "@/Page/EssAdmin/Announcement/components/showDetailReaded";
export default {
  name: "newAnnouncement",
  components: { showDetailReaded },
  computed: {
    ...mapGetters(["companyLang", "AppInfo", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    filter() {
      return (item, search, textKey) =>
        this.$getCommonLangValue(item[textKey]).indexOf(search) > -1;
    },
    curSend() {
      let arr = [];
      const that = this;
      if (!that.announcementData.send_org_level_uuid) arr = [];
      function getSon(items) {
        let arr1 = [];
        items.map((item) => {
          if (
            that.announcementData.send_org_level_uuid.indexOf(item.uuid) != -1
          ) {
            arr1.push(item);
          }
          if (item.son_org && item.son_org.length) {
            arr1 = arr1.concat(getSon(item.son_org));
          }
        });
        return arr1;
      }
      if (that.orgData.length) arr = getSon(that.orgData);
      return arr;
    },
  },
  data() {
    return {
      search: "",
      dateTerminal: "",
      iSEdited: false,
      isChanged: false,
      showDetailReadedDialog: false,
      orgData: [],
      announcementData: {
        message_title: "",
        is_confirm_read: false,
        send_status: 2,
        send_status_detail: "",
        send_org_level_uuid: [],
        message_content: "",
        send_end_utc_datetime: "",
        send_start_utc_datetime: "",
      },
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getOrgList();
    this.getDetail();
  },
  methods: {
    hightLightKeyword(val, keyword) {
      val = this.$getCommonLangValue(val);
      if (val.indexOf(keyword) !== -1) {
        return val.replace(
          keyword,
          `<font style='background-color:rgba(0,0,0,0.12)'>${keyword}</font>`
        );
      } else {
        return val;
      }
    },
    removeOrg(item) {
      const index = this.announcementData.send_org_level_uuid.indexOf(item);
      if (index >= 0)
        this.announcementData.send_org_level_uuid.splice(index, 1);
    },
    showDetail: function () {
      this.showDetailReadedDialog = true;
    },
    toRefuse() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/revocation/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_Announcement_form_revocationSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        if (res.data && res.data.send_org_level_uuid)
          res.data.send_org_level_uuid =
            res.data.send_org_level_uuid.split(",");
        if (res.data.is_confirm_read !== undefined)
          res.data.is_confirm_read = Number(res.data.is_confirm_read);

        that.announcementData = res.data;
      });
    },
    getOrgList: function () {
      const that = this;
      this.$getStaffList({}, true, false).then((res) => {
        if (JSON.stringify(res) == "{}" || !res) {
          that.orgData = [];
        } else {
          that.orgData = [res];
        }
      });
    },
  },
};
</script>
